import { render, staticRenderFns } from "./ProceedingGroup.vue?vue&type=template&id=23f1bd66&scoped=true"
import script from "./ProceedingGroup.vue?vue&type=script&lang=js"
export * from "./ProceedingGroup.vue?vue&type=script&lang=js"
import style0 from "./ProceedingGroup.vue?vue&type=style&index=0&id=23f1bd66&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1bd66",
  null
  
)

export default component.exports